var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAPonsCustom02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235.69 235.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".h{stroke-width:4.87px;}.h,.i{fill:none;stroke:#fff;stroke-miterlimit:10;}.i{stroke-width:5.06px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M184.3,129.35v82.65H101.65v-23.78c8.13,0,14.72-6.59,14.72-14.72s-6.59-14.72-14.72-14.72v-29.44h27.17c0,8.13,6.59,14.72,14.72,14.72s14.72-6.59,14.72-14.72h26.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M86.93,85.2c0,8.13,6.59,14.72,14.72,14.72v29.44h-26.04c0,8.13-6.59,14.72-14.72,14.72s-14.72-6.59-14.72-14.72H19V46.7H101.65v23.78c-8.13,0-14.72,6.59-14.72,14.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M217.13,15V97.65h-26.04c0,8.13-6.59,14.72-14.72,14.72s-14.72-6.59-14.72-14.72h-27.17v-29.44c-8.13,0-14.72-6.59-14.72-14.72s6.59-14.72,14.72-14.72V15h82.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M116.37,173.51c0,8.13-6.59,14.72-14.72,14.72v23.78H19v-82.65h27.17c0,8.13,6.59,14.72,14.72,14.72s14.72-6.59,14.72-14.72h26.04v29.44c8.13,0,14.72,6.59,14.72,14.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAPonsCustom02);
export default __webpack_public_path__ + "static/media/APons_Custom-02.8fa8b60f83b90646481bfa792282952e.svg";
export { ForwardRef as ReactComponent };